export default {
  SUCCESS: 'TOKENISATION_COMPLETE',
  ERROR: 'TOKENISATION_ERROR'
}
